export const exotichighimpact = {
  name: 'Exotic & High-impact',
  color: [0.45098039215686275, 0.3764705882352941, 0.3568627450980392, 1],
  bg: [0.058823529411764705, 0.12156862745098039, 0.2196078431372549, 1],
  grid1: [0.9607843137254902, 0.32941176470588235, 0.28627450980392155, 1],
  grid2: [0.10588235294117647, 0.29411764705882354, 0.35294117647058826, 1],
}
